import { Button } from '@mantine/core'
import { modals } from '@mantine/modals'

import { useRouter } from 'src/v2/commons/utils/navigation'

import AppModalContent, { type AppModalContentProps } from '../ModalContent'
import { MODAL_COLOR } from '../modalConfig'
import { EnumModalType } from '../types'

export type ModalSuccessProps = {
  buttonText?: string
  path?: string
  onClickBtn?: () => void
  onClose?: () => void
  onCancel?: () => void
  closeOnSuccess?: () => void
} & AppModalContentProps

const ModalNotificationContent = (props: ModalSuccessProps) => {
  const {
    type = EnumModalType.SUCCESS,
    buttonText,
    path,
    onClickBtn,
    closeOnSuccess,
  } = props
  const router = useRouter()

  const handleNavigate = () => {
    router.push(path ?? '')
  }

  const handleClickBtn = () => {
    if (path) {
      handleNavigate()
    } else if (onClickBtn) {
      onClickBtn()
    }
    if (closeOnSuccess) {
      closeOnSuccess()
    } else {
      modals.closeAll()
    }
  }

  return (
    <>
      <AppModalContent {...props} />
      {buttonText && (
        <Button
          mt={4}
          w="100%"
          onClick={handleClickBtn}
          bg={MODAL_COLOR[type]}
          variant="filled"
        >
          {buttonText}
        </Button>
      )}
    </>
  )
}

export default ModalNotificationContent
